import React from "react";
// import Banner from "../../components/UserSideComponents/privacypolicy/Banner";
import Privacy from "../../components/UserSideComponents/privacypolicy/Privacy";
import PersonalInformation from "../../components/UserSideComponents/privacypolicy/PersonalInformation";
import PersonalInformation2 from "../../components/UserSideComponents/privacypolicy/PersonalInformation2";
import AutomaticInformation from "../../components/UserSideComponents/privacypolicy/AutomaticInformation";
import HowUseInformation from "../../components/UserSideComponents/privacypolicy/HowUseInformation";
import NewsLetter from "../../components/UserSideComponents/privacypolicy/NewsLetter";
import Security from "../../components/UserSideComponents/privacypolicy/Security";
import Disclosure from "../../components/UserSideComponents/privacypolicy/Disclosure";
import ExternalWebsite from "../../components/UserSideComponents/privacypolicy/ExternalWebsite";
import TotalPrivacy from "../../components/UserSideComponents/privacypolicy/TotalPrivacy";
import Banner from "../../components/UserSideComponents/abouts/Banner";

const PrivacyPolicy = () => {
  return (
    <div>
      <Banner title="Privacy Policy" />
      <Privacy />
      <PersonalInformation />
      <PersonalInformation2 />
      <AutomaticInformation />
      <HowUseInformation />
      <NewsLetter />
      <Security />
      <Disclosure />
      <ExternalWebsite />
      <TotalPrivacy />
    </div>
  );
};

export default PrivacyPolicy;
